module.exports = __webpack_public_path__ + "img/2.2ac3c4f6.png";